import s from "../clinic.module.css";
import { Input, TimePicker } from "../../ui";
import {
  SCHEDULE_DURATION_PRESETS,
  formatDurationPresetLabel,
  normalizeDurationMin,
} from "./scheduleStepUtils";

export default function ScheduleTimeDurationFields({
  startTime,
  durationMin,
  onStartTimeChange,
  onDurationChange,
  durationPresets = SCHEDULE_DURATION_PRESETS,
}) {
  const normalizedDuration = normalizeDurationMin(durationMin);
  const durationValue =
    durationMin === "" || durationMin == null ? "" : normalizedDuration;

  return (
    <>
      <div className={s.onboardingScheduleTimeRow}>
        <label className={s.onboardingScheduleTimeField} htmlFor="schedule-start-time">
          <span className={s.onboardingScheduleTimeLabel}>Начало</span>
          <TimePicker
            id="schedule-start-time"
            value={startTime}
            onChange={onStartTimeChange}
            className={s.onboardingScheduleInput}
          />
        </label>
        <label className={s.onboardingScheduleTimeField} htmlFor="schedule-duration">
          <span className={s.onboardingScheduleTimeLabel}>Длительность (мин)</span>
          <Input
            id="schedule-duration"
            type="number"
            min={1}
            max={600}
            step={1}
            inputMode="numeric"
            value={durationValue}
            onChange={(e) => onDurationChange(e.target.value)}
            placeholder="60"
            className={s.onboardingScheduleInput}
          />
        </label>
      </div>

      <div className={s.onboardingScheduleDurationRow}>
        <span className={s.onboardingScheduleDurationLabel}>Быстро</span>
        {durationPresets.map((minutes) => (
          <button
            key={minutes}
            type="button"
            className={
              normalizedDuration === minutes
                ? s.onboardingScheduleDurationChipActive
                : s.onboardingScheduleDurationChip
            }
            onClick={() => onDurationChange(String(minutes))}
          >
            {formatDurationPresetLabel(minutes)}
          </button>
        ))}
      </div>
    </>
  );
}
